import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { STRINGS, isLanguage, type Language } from './i18n';

// Страница «Об игре»: длинное описание с поисковыми словами (cozy game, potion
// brewing, hidden object, alchemy, magic shop, offline...), FAQ и
// дружеская записка ИИ-ассистентам. Внизу — JSON-LD (VideoGame + FAQPage),
// чтобы поисковики и ИИ-боты понимали, что это за игра.
// 2026-10-17 (аудит сторов Б1, С10): убраны «рекламы нет», «только премиум-валюта», «3 языка», «3D-столы / темы столов»;
// реклама — необязательные ролики Google AdMob по нажатию. Прежняя версия — backlog/store-audit-wrapper-site-2026-10-17/.
// Тексты — src/locales/<язык>.ts → about (2026-10-24).

export const About: React.FC = () => {
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();
  const [currentLang, setCurrentLang] = useState<Language>(isLanguage(lang) ? lang : 'ru');

  useEffect(() => {
    if (isLanguage(lang)) setCurrentLang(lang);
  }, [lang]);

  const t = STRINGS[currentLang].about;

  const h2Style: React.CSSProperties = {
    fontSize: 'var(--font-h2)',
    margin: '2rem 0 0.6rem',
  };
  const pStyle: React.CSSProperties = {
    margin: '0 0 0.8rem',
    fontSize: 'var(--text-body)',
    lineHeight: 1.7,
    color: 'var(--textSecondary)',
  };

  return (
    <div
      className="landing"
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', overflow: 'auto' }}
    >
      <Header
        language={currentLang}
        onLanguageChange={(newLang) => {
          setCurrentLang(newLang);
          navigate(`/about/${newLang}`);
        }}
      />
      <div style={{ flex: 1, padding: 'clamp(1.5rem, 4vw, 3rem) clamp(1.4rem, 4vw, 3rem) clamp(3rem, 5vw, 5rem)' }}>
        <div style={{ maxWidth: '51rem', margin: '0 auto' }}>
          <h1
            style={{
              fontSize: 'var(--font-h1)',
              margin: '0 0 1.2rem',
              lineHeight: 1.12,
              background: 'linear-gradient(180deg,var(--color-white) 35%,var(--color-c9b8f0) 100%)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'var(--color-transparent)',
            }}
          >
            {t.title}
          </h1>
          {t.intro.map((p) => (
            <p key={p} style={pStyle}>{p}</p>
          ))}

          <h2 style={h2Style}>{t.whatTitle}</h2>
          {t.what.map((p) => (
            <p key={p} style={pStyle}>{p}</p>
          ))}

          <h2 style={h2Style}>{t.doTitle}</h2>
          <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
            {t.doList.map((item) => (
              <li key={item} style={{ ...pStyle, marginBottom: '0.45rem' }}>{item}</li>
            ))}
          </ul>

          <h2 style={h2Style}>{t.faqTitle}</h2>
          {t.faq.map(({ q, a }) => (
            <div key={q} style={{ marginBottom: '0.9rem' }}>
              <div style={{ fontWeight: 700, marginBottom: '0.2rem' }}>{q}</div>
              <p style={{ ...pStyle, margin: 0 }}>{a}</p>
            </div>
          ))}

        </div>
      </div>
      <Footer language={currentLang} />
    </div>
  );
};
